<template>
  <b-modal
    id="multi-branches-modal"
    v-model="multiBranchesModal"
    dialog-class="multi-branches-modal"
    body-class="pb-2"
    cancel-variant="secondary"
    size="lg"
    centered
    hide-footer
    :title="$t('branch.multi-branches')"
    lazy
    no-close-on-backdrop
  >
    <error-alert :error="error" />

    <div class="d-lg-flex align-items-center d-block">
      <div class="pr-3 text-center">
        <multi-branches-icon />
      </div>
      <div>
        <div class="font-weight-semi-bold mb-2 text-secondary">
          {{ $t('branch.multi-branches-description') }}
        </div>
        <div class="description-text font-weight-semi-bold mb-1">
          {{ $t('branch.can-add-branch-by') }}
        </div>
        <div>
          <select-add-branch-method
            v-model="createMethod"
            :branch-id.sync="clonedBranchId"
            :clone-text="$t('branch.taking-copy')"
            :create-text="$t('branch.creating-empty')"
          />
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-end mt-2">
      <b-button
        variant="link"
        :disabled="creating"
      >
        <span
          class="text-secondary"
          @click="handleNotHave"
        >
          {{ $t('branch.dont-have') }}
        </span>
      </b-button>
      <b-button
        size="lg"
        variant="dark"
        :disabled="creating"
        @click="handleAddBranch"
      >
        <b-spinner
          v-if="creating"
          small
        />
        <span v-else>{{ $t('forms.add') }}</span>
      </b-button>
    </div>

    <upgrade-modal
      v-model="upgradeModal"
      feature="branch.branch"
      feature-slug="branch"
      :limit="$store.getters['subscription/branchesLimit']"
    />
  </b-modal>
</template>

<script>
import { BModal, BButton, BSpinner } from 'bootstrap-vue'
import MultiBranchesIcon from '@/@okmenu/icons/MultiBranchesIcon'
import SelectAddBranchMethod from '@/@okmenu/components/modals/branches/SelectAddBranchMethod'
import AddBranchMixin from '@/mixins/add-branch-mixin'
import ErrorAlert from '@/@okmenu/components/alerts/ErrorAlert'
import UpgradeModal from '@/views/admin/purchase/components/UpgradeModal'

export default {
  name: 'MultiBranchesModal',
  components: {
    UpgradeModal,
    ErrorAlert,
    SelectAddBranchMethod,
    MultiBranchesIcon,
    BModal,
    BButton,
    BSpinner,
  },
  mixins: [AddBranchMixin],
  data() {
    return {
      creating: false,
      error: null,
      upgradeModal: false,
    }
  },
  methods: {
    handleAddBranch() {
      if (this.$store.getters['subscription/branchesLimit'] <= this.$store.getters['branches/branches'].length) {
        this.upgradeModal = true
        return
      }

      this.creating = true
      this.error = null

      this.addBranch()
        .then(() => { this.multiBranchesModal = false })
        .catch(error => { this.error = error })
        .finally(() => { this.creating = false })
    },
    handleNotHave() {
      this.multiBranchesModal = false
      this.$store.commit('branches/SET_ADD_BRANCH_TOUR', true)
    },
  },
}
</script>
